import * as yup from 'yup'

const schema = yup.lazy((values) =>
  yup.object(
    Object.keys(values).reduce(
      (shape, fieldName) => ({
        ...shape,
        [fieldName]: yup
          .bool()
          .oneOf([true], 'É necessário aceitar o regulamento para continuar'),
      }),
      {},
    ),
  ),
)

export default schema
